import React, { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import "./App.css";
import RaceSearch from "./searchView";
import TimeSlipView from "./TimeSlipView";
import LiveView from "./LiveView";
import QualView from "./QualView";
import TrackEventSelector from "./TrackEventSelector";

import { PageLayout } from "./components/PageLayout";
import { useAuth } from './AuthProvider';
import { LiveStatusProvider } from "./LiveStatusContext";
import { useInstallPrompt } from "./hooks/useInstallPrompt";
import InstallPromptBanner from "./components/InstallPromptBanner";

import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from "react-router-dom";
import NavBar from "./NavBar";
import WatchList from "./WatchList";

import WatchListRaceHistoryTable from "./watchList/watchList";

/**
 * Scroll the window to the top on every route change. Without this, navigating
 * (e.g. clicking Time Slip on a scrolled-down search result) lands the next
 * view at the previous page's scroll position.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

/**
 * Renders welcome message for the signed-in user or a button to retrieve welcome message from Spring Boot app
 */

/**
 * If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
 */
export const MainContent = () => {
  const { user, loading } = useAuth();
  const { showAndroidPrompt, showIOSGuide, handleInstallClick, handleDismiss, isAndroid, isIOS } = useInstallPrompt();

  if (loading) {
    return <div className="loader"></div>;
  }

  if (!user) {
    return (
      <div className="App">
        <PageLayout />
      </div>
    );
  }
  const HomeRedirect = () => {
  const hasTrackEventData = !!localStorage.getItem("trackEventSelection");

  // return hasTrackEventData ? <TimeSlipView /> : <TrackEventSelector />;
  return hasTrackEventData ? <Navigate to="/timeslip" replace /> : <TrackEventSelector />;
};

  return (
    <div className="App">
      <Toaster position="top-right" />
      <InstallPromptBanner
        showAndroidPrompt={showAndroidPrompt}
        showIOSGuide={showIOSGuide}
        onInstall={handleInstallClick}
        onDismiss={handleDismiss}
        isAndroid={isAndroid}
        isIOS={isIOS}
      />
      <Router>
        <ScrollToTop />
        <NavBar isAuthenticated={!!user} />
        <div className="App">
          <Routes>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/timeslip" element={<TimeSlipView />} />
            <Route path="/searchView" element={<RaceSearch />} />
            <Route path="/editTrackEvent" element={<TrackEventSelector />} />
            <Route path="/liveView" element={<LiveView />} />
            <Route path="/qualView" element={<QualView />} />
             <Route path="/watchList" element={<WatchListRaceHistoryTable />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
};

export default function App() {
  return (
    <LiveStatusProvider>
      <MainContent />
    </LiveStatusProvider>
  );
}
